"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
exports.createMuiCheckboxOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            color: undefined,
            padding: "calc(" + spacing(4) + "px - 0.75rem)",
            "& .MuiSvgIcon-root": {
                borderRadius: 2,
                fill: "transparent",
                stroke: palette.text.primary,
                transition: transitions.create(["fill", "stroke", "background-color"], {
                    duration: transitions.duration.shorter,
                }),
            },
        },
        colorPrimary: {
            "&&:hover, &&$checked:hover, &.Mui-focusVisible": {
                backgroundColor: "unset",
                boxShadow: "unset",
            },
            "&:hover .MuiSvgIcon-root": {
                stroke: "currentColor",
                fill: core_1.fade(palette.primary.main, 0.25),
            },
            "&.Mui-focusVisible .MuiSvgIcon-root": {
                stroke: "currentColor",
                fill: core_1.fade(palette.primary.main, 0.25),
                backgroundColor: core_1.fade(palette.primary.main, 0.25),
            },
            "&$disabled": {
                color: palette.action.disabled,
            },
        },
        disabled: {
            "& .MuiSvgIcon-root": {
                stroke: "currentColor",
            },
        },
    });
};
//# sourceMappingURL=MuiCheckbox.js.map